<template>
  <div>
    <ul :class="['navbar-nav bg-gradient-primary sidebar sidebar-dark',{ toggled: view.isToggle , 'system-sider-color' : view.systemStatus ==='commission_management' }]">
      <router-link
        class="sidebar-brand d-flex align-items-center justify-content-center"
        :to="memuConfig.link"
      >
        <div class="sidebar-brand-icon rotate-n-15">
          <i class="fas fa-desktop"></i>
        </div>
        <div class="sidebar-brand-text mx-3">
          {{ memuConfig.systemName }}
          <sup>v{{ memuConfig.version }}</sup>
        </div>
      </router-link>
      <hr class="sidebar-divider my-0" />
      <li class="nav-item active" v-if="dashboardConfig.display">
        <router-link class="nav-link" :to="dashboardConfig.link" @click.native="goToDashboard()">
          <i class="fas fa-fw fa-tachometer-alt"></i>
          <span>{{ dashboardConfig.title }}</span>
        </router-link>
      </li>
      <hr class="sidebar-divider" />
      <div class="nav-item" v-for="(item, index) in memuData" :key="index">
        <a
          data-toggle="collapse"
          :class="['nav-link','collapsed',{ arrow: item.isShow }]"
          :href="item.url"
          @click="subMenuToggleEvent(index)"
          v-show="item.meta.permission.includes('search')"
        >
          <i :class="item.icon"></i><span>{{ item.title }}</span>
        </a>
        <template v-if="item.children.length > 0">
          <div :class="['collapse',{ show: item.isShow }]" >
              <div class="bg-white py-2 collapse-inner rounded" >
                <template v-for="(subItem, key) in item.children"  >
                  <router-link v-if="!subItem.target"
                    :key="key"
                    tag="a"
                    :to="{path: subItem.url}"
                    :class="['collapse-item',{ isLock: subItem.isLock && view.systemStatus ==='commission_management'}]"
                    :target="subItem.target ? subItem.target : ''"
                    v-show="subItem.meta.permission.includes('search')"
                    @click.native="changePage(index)"
                  >
                    {{ subItem.name }}
                  </router-link>

                  <a v-else
                    :key="key"
                    :class="['collapse-item',{ isLock: subItem.isLock && view.systemStatus ==='commission_management'}]"
                    :href="subItem.url"
                    :target="subItem.target">
                    {{ subItem.name }}
                  </a>
                </template>
              </div>
          </div>
        </template>
      </div>
      <hr class="sidebar-divider d-none d-md-block" />
      <div class="text-center d-none d-md-inline">
        <button
          class="rounded-circle border-0"
          id="sidebarToggle"
          @click="sidebarToggleEvent"
        ></button>
      </div>
    </ul>
  </div>
</template>

<script>
import Global from '@/models/UI/Global'

export default {
  name: "Sidebar",
  props: {
    memuData: {
      type: Array,
      required: true,
      default: []
    },
    memuConfig: {
      type: Object,
      required: true,
      default: () => {}
    },
    dashboardConfig: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      show:false,
      view: {
        toggleKey: 0,
        isToggle: false,
        systemStatus: ''
      },
      subMenu: []
    };
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      Global.$on('isToggle', (isToggle) => {
        this.view.isToggle = isToggle;
      });
      Global.$on('systemStatus', (systemStatus) => {
        this.view.systemStatus = systemStatus;
      });
    },
    subMenuToggleEvent(toggleKey) {
      //除了自己子選單，其他都關閉
      for(let i = 0; i < this.memuData.length ;i++){
        if(i !== toggleKey) this.memuData[i].isShow = false;
      };
      //延遲一段時間在更改子選單狀態
      // let waitResult = setInterval(() => {
      //   this.memuData[toggleKey].isShow = !this.memuData[toggleKey].isShow;
      //   localStorage.setItem('sideBar', JSON.stringify(this.memuData)); //側邊欄重整子選單不能關閉
      //   clearInterval(waitResult);
      // }, 170);
      this.memuData[toggleKey].isShow = !this.memuData[toggleKey].isShow;
      localStorage.setItem('sideBar', JSON.stringify(this.memuData)); //側邊欄重整子選單不能關閉
    },
    async sidebarToggleEvent() {
      this.view.isToggle = !this.view.isToggle;
    },
    changePage(toggleKey) {
      const clientWidth = document.documentElement.clientWidth;

      if (clientWidth >= 900 && this.view.isToggle || clientWidth < 900) {
        this.memuData[toggleKey].isShow = false;

        localStorage.setItem('sideBar', JSON.stringify(this.memuData));
      }
    },
    // 去儀錶板
    goToDashboard() {
      // 子選單列表全關閉
      this.memuData.forEach(item => {
        item.isShow = false;
      })
    }
  },
};
</script>

<style lang="scss" scope>
.isLock {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/SideBar.vue